export default __webpack_public_path__ + "static/media/angry (1).ba6f0c3c.png";